import React, { useState } from 'react';
import * as Icons from '@cleartrip/bento-icons/src/components/Icons';
import {Search} from '@cleartrip/bento-icons/src/components/Icons'
import IconItem from '../IconItem';
import {Field, Spacer, Callout} from '@cleartrip/bento/lib'

const allIconNames = Object.keys(Icons).sort();

function IconList() {
	const [query, setQuery] = useState('');
	const filteredIcons = allIconNames.reduce((IconsToShow, Icon) => {
		if (Icon.toLowerCase().includes(query.toLowerCase()))
			return (IconsToShow = [...IconsToShow, <IconItem className="c-success-500" hover IconComponent={Icons[Icon]} label={Icon} />]);
		return IconsToShow;
	}, []);
	return (
		<div>
			<Spacer className='pt-3' />
			<div className='p-relative '>
				<Field placeholder='Search bento icons' onChange={(e) => setQuery(e.target.value)} />
				<span className='p-absolute r-3 t-2'>
					<Search height={20} width={20} className='c-neutral-400' />
				</span>
			</div>
			<Spacer className='pt-5' />
			<div className='flex flex-wrap nmx-2'>
				{filteredIcons.length > 0 ? (
					filteredIcons
				) : (
					<Callout variant='badge' label='NOTE' className='mx-2 w-100p'>
						There is no matching result found
					</Callout>
				)}
			</div>
		</div>
	);
}

export default IconList;
